module.exports = __webpack_public_path__ + "static/media/map.ae201233.png";